module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-driver-reservations"
  }, [_c('div', {
    staticClass: "action-bar"
  }, [_vm._m(0), _c('div', {
    staticClass: "action"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-2x",
    on: {
      "click": _vm.createDriverLicense
    }
  })])]), _c('div', {
    staticClass: "column row"
  }, _vm._l((_vm.licenses), function(license) {
    return _c('div', {
      staticClass: "columns small-12 medium-8 medium-offset-2 driver-licenses"
    }, [_c('driver-licence', {
      attrs: {
        "type": 'license-card-accordion',
        "item": license
      }
    })], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Driver Licenses")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-766a3796!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/DriverLicenses.vue
// module id = 2609
// module chunks = 1